import { useEffect } from "react";

const ADSENSE_SCRIPT_ID =
  "google-adsense-script";

const normalizePublisherId = (
  value = "",
) => {
  return String(value)
    .trim()
    .replace(/\s+/g, "");
};

const isValidPublisherId = (
  value,
) => {
  return /^ca-pub-\d{16}$/.test(
    value,
  );
};

const AdSenseScript = () => {
  useEffect(() => {
    const adsEnabled =
      process.env
        .REACT_APP_ADSENSE_ENABLED ===
      "true";

    const publisherId =
      normalizePublisherId(
        process.env
          .REACT_APP_ADSENSE_CLIENT,
      );

    /*
     * Development aur disabled mode me
     * AdSense script load nahi hoga.
     */
    if (!adsEnabled) {
      return;
    }

    /*
     * Real AdSense Publisher ID ke bina
     * invalid script inject nahi karte.
     */
    if (
      !isValidPublisherId(
        publisherId,
      )
    ) {
      console.warn(
        "AdSense is enabled, but REACT_APP_ADSENSE_CLIENT is invalid.",
      );

      return;
    }

    /*
     * Script ek baar hi add hona chahiye.
     */
    if (
      document.getElementById(
        ADSENSE_SCRIPT_ID,
      )
    ) {
      return;
    }

    const script =
      document.createElement(
        "script",
      );

    script.id =
      ADSENSE_SCRIPT_ID;

    script.async = true;

    script.crossOrigin =
      "anonymous";

    script.src =
      `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${encodeURIComponent(
        publisherId,
      )}`;

    script.setAttribute(
      "data-ad-client",
      publisherId,
    );

    script.onerror = () => {
      console.error(
        "Google AdSense script failed to load.",
      );
    };

    document.head.appendChild(
      script,
    );

    /*
     * Script intentionally cleanup nahi karte.
     * Route change par AdSense script global
     * rehna chahiye.
     */
  }, []);

  return null;
};

export default AdSenseScript;